import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

// Bandeau non bloquant : nouvelle version détectée pendant l'utilisation → rechargement uniquement à la demande.
export const UpdateBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const on = () => setShow(true);
    window.addEventListener("sanitdocs:new-version", on);
    return () => window.removeEventListener("sanitdocs:new-version", on);
  }, []);
  if (!show) return null;
  return (
    <div data-testid="update-banner" className="fixed bottom-20 md:bottom-4 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-3 rounded-full bg-brand-900 text-white shadow-lg px-4 py-2 text-sm">
      <span>Une nouvelle version est disponible</span>
      <button data-testid="update-banner-refresh" onClick={() => window.location.reload()} className="inline-flex items-center gap-1 font-bold text-accent-300"><RefreshCw className="w-4 h-4" />Actualiser</button>
    </div>
  );
};
